import { BaseModal } from "@/components";
import clsx from "clsx";
import "./DocumentUploadModal.scss";
import { PropsWithChildren, ReactNode } from "react";
import { DocumentUploadModalHeader } from "@/components/ui/DocumentUploadModal/DocumentUploadModalHeader";
import { DocumentUploadModalContent } from "@/components/ui/DocumentUploadModal/DocumentUploadModalContent";
import { DocumentUploadModalFooter } from "@/components/ui/DocumentUploadModal/DocumentUploadModalFooter";

type DocumentUploadModalProps = PropsWithChildren<{
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: ReactNode;
}>;

const DocumentUploadModal = ({
  open,
  overrideClassNames,
  setOpen,
  children,
}: DocumentUploadModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-upload-modal-override", overrideClassNames)}
    >
      {children}
    </BaseModal>
  );
};

DocumentUploadModal.Header = DocumentUploadModalHeader;
DocumentUploadModal.Content = DocumentUploadModalContent;
DocumentUploadModal.Footer = DocumentUploadModalFooter;

export { DocumentUploadModal };
